import React, { useEffect, useState } from "react";
import {
  AddFlex,
  CustomInput,
  CustomText,
  PrimaryActionButton,
} from "../reusableStyles";
import {
  generateUUID,
  getOfferings,
  isArrayNullOrUndefined,
  isNullOrUndefined,
} from "../utils";
import { useDispatch } from "react-redux";
import TesimonialImageVideoUpload from "../Testimonials/TesimonialImageVideoUpload";
import { AddOrUpdateTestimonials } from "../Api/ApiEndPoints";
import { TestimonialTabs, inputHeight } from "../constants";
import { CircularProgress, MenuItem, Select } from "@mui/material";
import useWindowSize from "../Hooks/useWindowSize";
import { useSelector } from "react-redux";
import TestimonialPhotoUpload from "../Customization/TestimonialPhotoUpload";
import TextEditor from "../CreateOffering/TextEditor";
import { Rate } from "antd";
import RightDrawerHeader from "../Pages/OfferingsPages/OfferingCard/RightDrawerHeader";
import { callNonStoreApi } from "../NonStoreApis";
import { setUserTestimonialsAction } from "../Store/appTempSlice";
import { enqueueSnackbar } from "notistack";

function TestimonialForm({ closeDrawer, testimonial }) {
  const { isMobileView } = useWindowSize();
  const [loading, setLoading] = useState(true);
  const [offerings, setOfferings] = useState([]);
  const { features } = useSelector((state) => state.userFeatures.userFeatures);
  const [testimonialData, setTestimonialData] = useState();
  const dispatch = useDispatch();
  const [files, setFiles] = useState([]);
  const [isApiLoading, setIsApiLoading] = useState(false);
  const handleChangeTestimonialData = (key, value) => {
    setTestimonialData((prev) => {
      return {
        ...prev,
        [key]: value,
      };
    });
  };

  console.log(testimonialData);

  const getImageFile = (isMultiple, files) => {
    console.log(files);
    if (files) {
      setFiles(files);
      if (files[0].isVideo) {
        handleChangeTestimonialData("video", files);
      } else {
        handleChangeTestimonialData("imageGallery", files);
      }
    } else {
      setFiles(null);
      handleChangeTestimonialData("video", null);
      handleChangeTestimonialData("imageGallery", null);
    }
  };

  const addTestimonial = (e) => {
    e.preventDefault();
    setIsApiLoading(true);
    callNonStoreApi(AddOrUpdateTestimonials, { data: testimonialData })
      .then((response) => {
        dispatch(setUserTestimonialsAction(response.data.docs));
        closeDrawer();
      })
      .catch((error) => {
        enqueueSnackbar("Something went wrong", {
          variant: "error",
        });
      })
      .finally((error) => {
        setIsApiLoading(false);
      });
  };

  useEffect(() => {
    if (testimonial) {
      setTestimonialData(testimonial);
      if (!isArrayNullOrUndefined(testimonial.imageGallery))
        setFiles(testimonial.imageGallery);
      else if (!isArrayNullOrUndefined(testimonial.video)) {
        setFiles(testimonial.video);
      }
    } else {
      setTestimonialData({
        id: generateUUID(),
        source: TestimonialTabs.SELF,
        date: new Date(),
      });
    }
    const offerings = getOfferings(features);
    setOfferings(offerings);
    setLoading(false);
  }, []);

  return (
    testimonialData && (
      <>
        <RightDrawerHeader
          onClose={closeDrawer}
          headerText={
            isNullOrUndefined(testimonial)
              ? "Add Testimonial"
              : "Update Testimonial"
          }
        />
        {/* <AddFlex
          position="fixed"
          top="0px"
          right="0"
          alignItems="center"
          justify="space-between"
          width={isMobileView() ? "100%" : "35vw"}
          padding="5px "
          backgroundColor="white"
          style={{ zIndex: "1111", boxShadow: "0 0 0px 2px rgba(0,0,0,0.05)" }}
        >
          <CustomText
            style={{ flexShrink: "0" }}
            color={primaryTextColor}
            margin="10px"
            fontSize="16px"
          >
            {isNullOrUndefined(testimonial)
              ? "Add Testimonial"
              : "Update Testimonial"}
          </CustomText>
          <Close onClick={closeDrawer} />
        </AddFlex> */}
        <form
          style={{
            // marginTop: "30px",
            padding: "30px",
            position: "relative",
            paddingBottom: "80px",
          }}
          onSubmit={addTestimonial}
        >
          <AddFlex flexDirection="column" marginBottom="20px  ">
            <label>Service/Offering</label>
            <Select
              value={testimonialData.offering?.id}
              onChange={(e) => {
                const offering = offerings.find(
                  (offering) => offering.id === e.target.value
                );
                handleChangeTestimonialData("offering", offering);
              }}
              sx={{ marginTop: "8px", height: inputHeight }}
            >
              {offerings.map((offering) => (
                <MenuItem value={offering.id}>
                  <CustomText color="black">{offering.name}</CustomText>
                </MenuItem>
              ))}
            </Select>
          </AddFlex>
          <CustomInput
            placeholder={"Eg: Jhon Doe"}
            label={"Name"}
            style={{ margin: "0px 0 15px 0" }}
            value={testimonialData.name}
            onChange={(text) => handleChangeTestimonialData("name", text)}
          />
          <AddFlex gap="8px" flexDirection="column">
            <label for="rating">Rating</label>
            <Rate
              id="rating"
              allowHalf
              value={testimonialData.rating}
              onChange={(newValue) => {
                handleChangeTestimonialData("rating", newValue);
              }}
              style={{ margin: "0px 0 15px 0" }}
            />
          </AddFlex>
          <label for="feeback">Feedback</label>
          <TextEditor
            value={testimonialData.msg}
            getTextEditorInput={(text) =>
              handleChangeTestimonialData("msg", text)
            }
          />
          <CustomInput
            placeholder={"Eg: Jhon Doe"}
            label={"Occupation"}
            style={{ margin: "0px 0 15px 0" }}
            value={testimonialData.occupation}
            onChange={(text) => handleChangeTestimonialData("occupation", text)}
          />
          <CustomInput
            placeholder={"Eg: Jhon Doe"}
            label={"Workplace"}
            style={{ margin: "0px 0 15px 0" }}
            value={testimonialData.workplace}
            onChange={(text) => handleChangeTestimonialData("workplace", text)}
          />

          {/* <Tags
            selectedTags={testimonialData.tags}
            onChange={(tags) => {
              handleChangeTestimonialData("tags", tags);
            }}
          /> */}

          <div>
            <label>Upload Photo</label>
            <TestimonialPhotoUpload
              margin={"8px 0 15px 0"}
              photoURL={testimonialData.photoUrl}
              handleGetFile={(photo) =>
                handleChangeTestimonialData("photoUrl", photo)
              }
            />
          </div>

          <TesimonialImageVideoUpload
            getImageFile={getImageFile}
            setFiles={setFiles}
            files={files}
          />

          <AddFlex
            position="fixed"
            bottom="0px"
            right="0"
            width={isMobileView() ? "100%" : "35vw"}
            padding="10px 30px"
            backgroundColor="white"
            style={{
              zIndex: "1111",
              boxShadow: "0 0 0px 4px rgba(0,0,0,0.05)",
            }}
          >
            <PrimaryActionButton margin="0 auto" type="submit">
              {isApiLoading ? (
                <CircularProgress size={14} sx={{ color: "white" }} />
              ) : isNullOrUndefined(testimonial) ? (
                "Add Testimonial"
              ) : (
                "Update Testimonial"
              )}
            </PrimaryActionButton>
          </AddFlex>
        </form>
      </>
    )
  );
}

export default TestimonialForm;
